import React from 'react';

export interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  containerClassName?: string;
  inputClassName?: string;
  error?: string;
  readOnly?: boolean;
  showReadOnlyBadge?: boolean;
}

export const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      label,
      iconLeft,
      iconRight,
      containerClassName = '',
      inputClassName = '',
      error,
      type = 'text',
      readOnly = false,
      showReadOnlyBadge = false,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`formInputContainer ${containerClassName}`.trim()}>
        {label && (
          <label className="formInputLabel">{label}</label>
        )}
        <div className="formInputWrapper">
          {iconLeft && <span className="formInputIconLeft">{iconLeft}</span>}
          <input
            ref={ref}
            className={`formInput ${inputClassName}`.trim()}
            type={type}
            readOnly={readOnly}
            {...props}
          />
          {iconRight && <span className="formInputIconRight">{iconRight}</span>}
          {showReadOnlyBadge && readOnly && (
            <span className="formInputReadOnlyBadge">Read Only</span>
          )}
        </div>
        {error && <div className="formInputError">{error}</div>}
      </div>
    );
  }
);

export default InputField;
